/*
 * @Author: your name
 * @Date: 2021-08-23 20:43:12
 * @LastEditTime: 2022-07-04 18:53:07
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\Login\LoginFeishu\index.jsx
 */
import React, {Component} from 'react';
import LoginThirdBtn from "../LoginThirdBtn";
import feishuImg from '../../images/ic_feishu@2x.png'
import BsyBtn from "../BsyBtn";
import './index.css'
import { BsyUtils } from '../../utils/Utils'

class LoginFeishu extends Component {
    gotoFeishuLogin = () =>{
        BsyUtils.redirectTo(`/feishu/login`)
    }
    render() {
        const {changeContModePage, customLoginConfig} = this.props;
        const modeBtnShow={
            dingdingShow:true,
            workWechatShow:true,
            qyWechatShow:true,
            feishuShow:false,
            qyzjWechatShow:true,
            wechatShow:true,
            LoginAccountPasswordShow: true,
            LoginCodeShow: true,
            ssoShow: true,
        }
        return (
            <div className="LoginWorkWechat">
                <div className="loginContentBox">
                    <div className="title">
                        {React.language('feishu.login')}
                    </div>
                    <div className="feishuLogo">
                        <img src={feishuImg} alt=""/>
                    </div>
                    <BsyBtn style={{'marginBottom':'1.875rem'}} onClick={this.gotoFeishuLogin} text={React.language('account.signin.qrcode')} />
                </div>
                <LoginThirdBtn modeBtnShow={modeBtnShow} customLoginConfig={customLoginConfig} changeContModePage={changeContModePage} />
            </div>
        );
    }
}

export default LoginFeishu;